export default {
	NORMAL: 1,
	SLOW: 0.85,
	SLOWEST: 0.75,
	FAST: 1.25,
	FASTEST: 1.5,
}
